import React, {useState} from "react";
import axios from "axios";

import {useModal} from "@/hooks/useModal.jsx";
import ErrorNotification from "@/components/dialogs/ErrorNotification.jsx";

export const useFetchData = ({endpoint}) => {
    const {openModal} = useModal();

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({});

    const fetchData = (inputData) => {
        setIsLoading(true);

        callEndpoint(inputData).then(() => {
            setIsLoading(false);
        });
    };

    const clearFetchedData = () => {
        setData({});
    };

    const setEndpoint = (newEndpoint) => {
        endpoint = newEndpoint;
    }

    const callEndpoint = async (inputData) => {
        try {
            const response = await axios.get(
                endpoint = endpoint.indexOf('?') === -1 ? endpoint + '?load=true' : endpoint + '&load=true',
                {
                    params: inputData,
                    withCredentials: true,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    validateStatus: function (status) {
                        return status < 500;
                    },
                }
                );

            switch (response.status) {
                case 200:
                case 422:
                    setData(response.data ?? {});
                    break;
                default:
                    openModal(<ErrorNotification/>);
            }
        } catch (error) {
            console.error(error);

            openModal(<ErrorNotification/>);
        }
    };

    return {
        fetchData,
        clearFetchedData,
        setEndpoint,
        isLoading,
        data,
    };
};
